export default "__VITE_ASSET__BCSVtJmU__"